import { HttpInterceptorFn } from '@angular/common/http';
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldBypassAuth =
    !req.url.includes('api/') ||
    [
      'api/auth/local',
      'api/auth/forgot-password',
      'api/auth/reset-password',
    ].some((path) => req.url.includes(path));

  if (shouldBypassAuth) {
    return next(req);
  }

  const authToken = getStoredToken();
  if (!authToken) {
    return next(req);
  }
  // Clone the request and add the authorization header
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  // Pass the cloned request with the updated header to the next handler
  return next(authReq);
};

type StoredAuth = { jwt?: string };

const getStoredToken = (): string => {
  try {
    const stored = sessionStorage.getItem('user');
    if (!stored) {
      return '';
    }
    const parsed = JSON.parse(stored) as StoredAuth;
    return parsed?.jwt ?? '';
  } catch {
    return '';
  }
};
